<template>
  <div class='text-center'>
      <p>Only Admin account can moderate Session Votings</p>
      <p>Please log out and sign in again with Admin account</p>
      <button
        class='logout-button w-full lg:w-32 uppercase border mt-4 bg-pink-500 text-gray-50 px-8 py-2 text-center rounded-md hover:shadow-md cursor-pointer'
        @click='logoutApp'>
        Logout
      </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModeratorLogout',
  methods: {
    ...mapActions('users', [
      'logout',
    ]),
    logoutApp() {
      this.logout().then(() => {
        this.$router.push({ name: 'Login', query: { redirect_route: 'Moderator' } })
      })
    },
  }
}
</script>